import { NotificationSettings } from '../types';
import { apiFetch } from './apiClient';
import { apiEndpoints } from './env';

/**
 * ReachAI Notification Service
 * In production, integrate with EmailJS, SendGrid, or AWS SES via API.
 */
export const sendCriticalAlert = async (
  subject: string,
  message: string,
): Promise<boolean> => {
  const settingsStr = localStorage.getItem('reachai_notification_settings');
  if (!settingsStr) return false;

  const settings: NotificationSettings = JSON.parse(settingsStr);
  if (!settings.serviceEnabled || !settings.adminEmail) return false;

  console.log(`[ReachAI Alert Service] Sending Email to ${settings.adminEmail}`);
  console.log(`Subject: ${subject}`);
  console.log(`Body: ${message}`);

  return new Promise((resolve) => {
    setTimeout(() => resolve(true), 1000);
  });
};

/** GET /analytics — same auth as the app; avoids HEAD/no-cors issues. */
export const checkApiHealth = async (): Promise<boolean> => {
  if (!apiEndpoints.analytics) return false;
  try {
    const res = await apiFetch(apiEndpoints.analytics, {
      method: 'GET',
      timeoutMs: 15_000,
    });
    return res.ok;
  } catch {
    return false;
  }
};

/** @deprecated Use checkApiHealth */
export const checkWebhookHealth = async (url: string): Promise<boolean> => {
  if (!url || url.includes('example.com')) return false;
  try {
    const res = await apiFetch(url, { method: 'GET', timeoutMs: 15_000 });
    return res.ok;
  } catch {
    return false;
  }
};
